import type { CombinedColumnDef } from '@/api/dowload-excel.api'
import { formatDateTime } from '@/utils/format'
import type { HardQuestion } from '@/api/feedback-conversation.api'
import { Button } from '@/components/ui/button'
import { Tooltip } from '@/components/ui/tooltip'
import { TOOLTIP_STYLE } from '@/pages/libraries/LibrarySidebar'

interface BuildConversationColumnsOptions {
    pageIndex: number
    pageSize: number
    onAssignLabel: (record: HardQuestion) => void
}

export function buildConversationColumns(
    options: BuildConversationColumnsOptions,
): CombinedColumnDef<HardQuestion>[] {
    const { onAssignLabel } = options

    return [
        {
            id: 'date',
            accessorFn: (row) => row.updatedAt || row.createdAt,
            header: 'Ngày cập nhật',
            size: 150,
            cell: ({ getValue }) => formatDateTime(getValue() as string),
        },
        {
            accessorKey: 'robotName',
            header: 'Robot',
            size: 120,
        },
        {
            accessorKey: 'question',
            header: 'Nội dung',
            size: 260,
            cell: ({ getValue }) => (
                <Tooltip
                    title={getValue()}
                    placement="topLeft"
                    color="#fff"
                    styles={{ container: TOOLTIP_STYLE}}
                >
                    <span className="line-clamp-2">{getValue()}</span>
                </Tooltip>
            ),
        },
        {
            id: 'tagName',
            header: 'Nhãn',
            align: 'left',
            size: 200,
            cell: ({ row }) => {
                const displayLabel = row.original.label || row.original.tagName
                if (displayLabel) {
                    return (
                        <span className="inline-flex rounded-full bg-[#C7C8CA] px-3 py-1 text-white">
                            {displayLabel}
                        </span>
                    )
                }
                return null
            },
        },
        {
            id: 'action',
            size: 100,
            exportable: false,
            cell: ({ row }) => {
                const displayLabel = row.original.label || row.original.tagName
                if (!displayLabel) {
                    return (
                        <Button
                            variant="link"
                            onClick={() => onAssignLabel(row.original)}
                            className="text-[#CE7A58] !hover:text-[#CE7A58]/80 hover:underline"
                        >
                            Gán nhãn
                        </Button>
                    )
                }
                return null
            },
        },
    ]
}